function getAspectRatio(args) {
  return args.previewImageScale ?? (args.displayData ? args.displayData.proportions.height / args.displayData.proportions.width : 0.5625);
}

export { getAspectRatio };
//# sourceMappingURL=util.get-aspect-ratio.js.map
